import type { FormEventHandler } from 'react'

import Button from '@src/component/ButtonV2'
import Tooltip from '@ui/Tooltip'
import Typography from '@ui/Typography'
import { HStack } from '@ui/layout/Stack'

import * as styles from './CallQualityWizardIntentForm.css'

type SubmissionIntent = 'positive' | 'negative'

type SubmissionSchema = {
  type: 'intent'
  payload: {
    intent: SubmissionIntent
  }
}

type CallQualityWizardIntentFormProps = {
  onSubmit?: (submission: SubmissionSchema) => void
}

function CallQualityWizardIntentForm(props: CallQualityWizardIntentFormProps) {
  const handleSubmit: FormEventHandler<HTMLFormElement> = (evt) => {
    evt.preventDefault()
    if (!(evt?.nativeEvent instanceof SubmitEvent)) {
      return
    }
    const submitter = evt?.nativeEvent?.submitter as HTMLButtonElement
    props.onSubmit?.({
      type: 'intent',
      payload: { intent: submitter.value as SubmissionIntent },
    })
  }
  return (
    <form onSubmit={handleSubmit}>
      <HStack gap={10}>
        <Tooltip title="Bad" themeKey="dark">
          {/* eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button */}
          <Button
            name="intent"
            value="negative"
            color="neutral"
            height={44}
            className={styles.button}
          >
            {/*
             // @ts-expect-error Provide Typography with a component prop */}
            <Typography variant="emoji" className={styles.buttonEmoji}>
              👎
            </Typography>
          </Button>
        </Tooltip>
        <Tooltip title="Great" themeKey="dark">
          {/* eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button */}
          <Button
            name="intent"
            value="positive"
            color="neutral"
            height={44}
            className={styles.button}
          >
            {/*
             // @ts-expect-error Provide Typography with a component prop */}
            <Typography variant="emoji" className={styles.buttonEmoji}>
              👍
            </Typography>
          </Button>
        </Tooltip>
      </HStack>
    </form>
  )
}

export type { SubmissionSchema as CallQualityWizardIntentFormSubmissionSchema }

export default CallQualityWizardIntentForm
